/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ConfirmFufuHotelReservation200Response
 */
export interface ConfirmFufuHotelReservation200Response {
    /**
     * 
     * @type {number}
     * @memberof ConfirmFufuHotelReservation200Response
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof ConfirmFufuHotelReservation200Response
     */
    'reservationCode': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmFufuHotelReservation200Response
     */
    'status': ConfirmFufuHotelReservation200ResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ConfirmFufuHotelReservation200Response
     */
    'amount': number;
}

export const ConfirmFufuHotelReservation200ResponseStatusEnum = {
    success: 'SUCCESS',
    reservationUnconfirmed: 'RESERVATION_UNCONFIRMED',
    notFound: 'NOT_FOUND',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    alreadyRegistered: 'ALREADY_REGISTERED',
    unspecified: 'UNSPECIFIED'
} as const;

export type ConfirmFufuHotelReservation200ResponseStatusEnum = typeof ConfirmFufuHotelReservation200ResponseStatusEnum[keyof typeof ConfirmFufuHotelReservation200ResponseStatusEnum];


